import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { showOpenTicketModal } from '../../managers/modal'
import { Transition } from '@headlessui/react'
import { useDispatch, useSelector } from 'react-redux'
import { messagesSelectors } from 'store/messages'
import { settingsActions, settingsSelectors } from 'store/settings'

export const TicketReminderCard = () => {
  const { t } = useTranslation()
  const ticketReminderVisible = useSelector(settingsSelectors.ticketReminderVisible)
  const dispatch = useDispatch()
  const isInOperatorMode = useSelector(messagesSelectors.currentChatIsInOperatorMode)

  const onClickDismissHelp = useCallback(() => {
    dispatch(settingsActions.setTicketReminderVisible(false))
  }, [dispatch])

  return (
    <Transition
      show={ticketReminderVisible && !isInOperatorMode}
      className={'tw-mt-2'}
      enter="tw-transition-opacity tw-duration-300"
      enterFrom="tw-opacity-0"
      enterTo="tw-opacity-100"
      leave="tw-transition-opacity tw-duration-300"
      leaveFrom="tw-opacity-100"
      leaveTo="tw-opacity-0"
    >
      <div
        className={
          'tw-bg-primary-100 tw-p-2 tw-text-white tw-rounded-xl tw-transition-all tw-duration-500 tw-ease-in-out tw-text-sm'
        }
      >
        <div className={'tw-flex tw-flex-row tw-justify-between tw-items-center tw-space-x-1'}>
          <div>{t('needToOpenTicket')}</div>
          <div className={'tw-flex tw-flex-row tw-space-x-1'}>
            <div
              onClick={showOpenTicketModal}
              className={
                'tw-bg-primary-400 tw-text-white tw-h-8 tw-text-sm tw-w-8 tw-justify-center tw-rounded-full tw-items-center tw-flex tw-cursor-pointer'
              }
            >
              {t('yes')}
            </div>
            <div
              onClick={onClickDismissHelp}
              className={
                'tw-bg-primary-400 tw-text-white tw-text-sm tw-h-8 tw-w-8 tw-justify-center tw-rounded-full tw-items-center tw-flex tw-cursor-pointer'
              }
            >
              {t('no')}
            </div>
          </div>
        </div>
      </div>
    </Transition>
  )
}
